const lurkerSend = payload => {
  /* eslint-disable */
  try {
    if (window.Lurker && window.Lurker.send) {
      window.Lurker.send(payload)
    } else {
      console.log('LURKER EVENT: ', payload)
    }
  } catch (error) {
    console.error(`Error on send Lurker event: ${error}`)
  }
  /* eslint-enable */
}

export default lurkerSend
